import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    mobileno: '',
    query: '',
    location: '',
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Restrict mobile to 10 digits only
    if (name === 'mobileno') {
      const onlyDigits = value.replace(/\D/g, '');
      if (onlyDigits.length > 10) return;
      setFormData((prev) => ({ ...prev, [name]: onlyDigits }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    const phonePattern = /^[0-9]{10}$/;

    if (!formData.name.trim()) {
      newErrors.name = 'Please enter your name.';
    }

    if (!phonePattern.test(formData.mobileno.trim())) {
      newErrors.mobileno = 'Please enter a valid 10-digit mobile number.';
    }

    if (!formData.query.trim()) {
      newErrors.query = 'Please enter your query.';
    }

    if (!formData.location.trim()) {
      newErrors.location = 'Please enter your location.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const buildGmailUrl = ({ name, mobileno, query, location }) => {
    const to = 'kamblevishvapratap@gmail.com';
    const subject = 'Need Birdnetting Solution Pune';

    const body = `
Name: ${name}
Mobile: ${mobileno}
Location: ${location}

Query:
${query}
`.trim();

    return `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
      to
    )}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const isValid = validate();
    if (!isValid) return;

    const gmailUrl = buildGmailUrl(formData);
    // Open Gmail compose in new tab
    window.open(gmailUrl, '_blank', 'noopener,noreferrer');
  };

  const handleQuickEmailClick = () => {
    // Quick email (no form data) – still Gmail compose
    const to = 'kamblevishvapratap@gmail.com';
    const subject = 'Need Birdnetting Solution Pune';
    const body = 'I want connect for birdnetting service';

    const url = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
      to
    )}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <section id='contact' className='py-2 bg-light px-0'>
      <div className='container'>
        <div className='row justify-content-center'>
          <div className='col-lg-10'>
            {/* Section Header */}
            <div className='text-center mb-5' data-aos='fade-up'>
              <h2 className='fw-bold text-dark'>Contact Us</h2>
              <p className='text-muted'>
                Get in touch with <strong>Bird Netting Services</strong> — we’re
                here to provide the best solutions for your safety and peace of
                mind.
              </p>
            </div>

            {/* Quick Contact Buttons */}
            <div
              className='d-flex justify-content-center flex-wrap gap-3 mb-5'
              data-aos='fade-up'
              data-aos-delay='100'
            >
              <a
                href='tel:+919579858376'
                className='btn btn-primary px-4 py-2 rounded-pill shadow-sm d-flex align-items-center'
              >
                <i className='bi bi-telephone-fill me-2 fs-5'></i>Call Now
              </a>

              <a
                href='https://wa.link/nfcezm'
                target='_blank'
                rel='noopener noreferrer'
                className='btn px-4 py-2 rounded-pill shadow-sm d-flex align-items-center'
                style={{ backgroundColor: '#25d366', color: '#fff' }}
              >
                <i className='bi bi-whatsapp me-2 fs-5'></i>WhatsApp
              </a>

              {/* New: Gmail quick email button */}
              <button
                type='button'
                className='btn btn-outline-primary px-4 py-2 rounded-pill shadow-sm d-flex align-items-center'
                onClick={handleQuickEmailClick}
              >
                <i className='bi bi-envelope-fill me-2 fs-5'></i>Gmail
              </button>
            </div>

            {/* Contact Form + Map */}
            <div className='row g-4 align-items-stretch'>
              {/* Contact Form */}
              <div className='col-12 col-lg-6' data-aos='fade-right'>
                <div className='card border-0 shadow-lg h-100'>
                  <div className='card-body p-4'>
                    <h5 className='fw-semibold text-primary mb-3'>
                      <i className='bi bi-chat-dots-fill me-2'></i>Email Contact
                    </h5>

                    <form id='contactForm' noValidate onSubmit={handleSubmit}>
                      {/* Name */}
                      <div className='mb-3'>
                        <label
                          htmlFor='name'
                          className='form-label fw-semibold'
                        >
                          Full Name
                          <span className='text-danger'>*</span>
                        </label>
                        <input
                          type='text'
                          id='name'
                          name='name'
                          className={`form-control rounded-3 ${
                            errors.name ? 'is-invalid' : ''
                          }`}
                          placeholder='Enter your name'
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                        {errors.name && (
                          <div className='invalid-feedback'>{errors.name}</div>
                        )}
                      </div>

                      {/* Mobile Number */}
                      <div className='mb-3'>
                        <label
                          htmlFor='mobileno'
                          className='form-label fw-semibold'
                        >
                          Mobile Number
                          <span className='text-danger'>*</span>
                        </label>
                        <input
                          type='tel'
                          id='mobileno'
                          name='mobileno'
                          className={`form-control rounded-3 ${
                            errors.mobileno ? 'is-invalid' : ''
                          }`}
                          placeholder='Enter your mobile number'
                          value={formData.mobileno}
                          onChange={handleChange}
                          required
                        />
                        {errors.mobileno && (
                          <div className='invalid-feedback'>
                            {errors.mobileno}
                          </div>
                        )}
                      </div>

                      {/* Query */}
                      <div className='mb-3'>
                        <label
                          htmlFor='query'
                          className='form-label fw-semibold'
                        >
                          Your Query
                          <span className='text-danger'>*</span>
                        </label>
                        <textarea
                          id='query'
                          name='query'
                          rows='4'
                          className={`form-control rounded-3 ${
                            errors.query ? 'is-invalid' : ''
                          }`}
                          placeholder='birdnetting, birdnet, invisible grill...'
                          value={formData.query}
                          onChange={handleChange}
                          required
                        ></textarea>
                        {errors.query && (
                          <div className='invalid-feedback'>{errors.query}</div>
                        )}
                      </div>

                      {/* Location */}
                      <div className='mb-3'>
                        <label
                          htmlFor='location'
                          className='form-label fw-semibold'
                        >
                          Location
                          <span className='text-danger'>*</span>
                        </label>
                        <input
                          type='text'
                          id='location'
                          name='location'
                          className={`form-control rounded-3 ${
                            errors.location ? 'is-invalid' : ''
                          }`}
                          placeholder='Pune Land-mark Only'
                          value={formData.location}
                          onChange={handleChange}
                          required
                        />
                        {errors.location && (
                          <div className='invalid-feedback'>
                            {errors.location}
                          </div>
                        )}
                      </div>

                      {/* Submit */}
                      <button
                        type='submit'
                        className='btn btn-primary w-100 py-2 rounded-pill fw-semibold shadow-sm'
                      >
                        <i className='bi bi-send-fill me-2'></i>Submit & Open
                        Gmail
                      </button>
                    </form>
                  </div>
                </div>
              </div>

              {/* Google Map */}
              <div className='col-12 col-lg-6' data-aos='fade-left'>
                <div className='card border-0 shadow-lg overflow-hidden h-100'>
                  <div className='map-responsive'>
                    <iframe
                      title='Bird Netting Location'
                      src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11441.74704743733!2d73.86139772372456!3d18.622856538737498!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c79fe678d5a9%3A0xad6afcbc521d41c6!2sMahadev%20Nagar%2C%20Dighi%2C%20Pimpri-Chinchwad%2C%20Maharashtra%20411039!5e0!3m2!1sen!2sin!4v1762594108523!5m2!1sen!2sin'
                      allowFullScreen
                      loading='lazy'
                      referrerPolicy='no-referrer-when-downgrade'
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Inline styling kept similar to your original HTML */}
      <style>{`
        #contact {
          width: 100%;
        }

        #contact .card {
          border-radius: 10px;
        }

        #contact .form-control:focus {
          border-color: #0e0f0fff;
          box-shadow: 0 0 0 0.2rem rgba(30, 136, 229, 0.25);
        }

        #contact .invalid-feedback {
          display: block;
          color: #dc3545;
          font-size: 0.875rem;
        }

        .map-responsive {
          position: relative;
          overflow: hidden;
          width: 100%;
          padding-top: 100%;
        }

        .map-responsive iframe {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border: 0;
        }

        @media (max-width: 768px) {
          #contact h2 {
            font-size: 1.6rem;
          }
          #contact .card-body {
            padding: 1.5rem;
          }
          .map-responsive {
            padding-top: 100%;
          }
        }
      `}</style>
    </section>
  );
};

export default Contact;
